import {PopperPlacementType} from "@mui/base/PopperUnstyled/PopperUnstyled.types";
import {CSSProperties} from "react";

export function getOppositeTransformOrigin(placement: PopperPlacementType): CSSProperties['transformOrigin'] {
    switch (placement) {
        case 'top':
            return 'bottom';
        case 'bottom':
            return 'top';
        case 'left':
            return 'right';
        case 'right':
            return 'left';
        case 'top-start':
            return 'bottom left';
        case 'top-end':
            return 'bottom right';
        case 'bottom-start':
            return 'top left';
        case 'bottom-end':
            return 'top right';
        case 'left-start':
            return 'right top';
        case 'left-end':
            return 'right bottom';
        case 'right-start':
            return 'left top';
        case 'right-end':
            return 'left bottom';
        default:
            return 'center';
    }
}